// extracted by mini-css-extract-plugin
module.exports = {"painting":"painting___33tdO","innerCard":"innerCard___2DVEv","BSPPrint":"BSPPrint___3pZK3","bspCommontContain":"bspCommontContain___2L-HC"};